// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"CenteredWindowLayout_contentWrapper__SpTsf","content":"CenteredWindowLayout_content__1EB0S","alignerItemFixed":"CenteredWindowLayout_alignerItemFixed__DcdOS"};